import React from 'react';
import Terms from '../Components/Terms/Terms';
import Combaintop from '../Components/Combaintop/Top';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Breadcrumbs from '../Components/banner/New-banner';
function TermsAndCondition() {
  return (
    <div>
        <Combaintop/>
        <Breadcrumbs/>
        <Terms/>
        <Combainbottom/>
    </div>
  )
}

export default TermsAndCondition
